import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';

@Injectable({
    providedIn: 'root'
  })
export class ConfirmEmailValidator {

    confirmation_code = [
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(6),
        Validators.pattern('^-?[0-9]\\d*(\\.\\d{1,2})?$')
    ];


    // Error messages
    errorMessages = {

        confirmation_code: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            },
            {
                type: 'minlength', 
                message: 'MESSAGES.MINIMUM_NUMBER',
                options: { minStr: '6' }
            },
            {
                type: 'maxlength', 
                message: 'MESSAGES.MAXIMUM_NUMBER',
                options: { maxStr: '6' }
            },
            {
                type: 'pattern', 
                message: 'MESSAGES.CODE_CONFIRMATION',
                options: null
            },
            {
                type: 'mustMatch', 
                message: 'MESSAGES.PASWORD_CONFIRMATION',
                options: null
            }
        ]
    }
}